import { ISubsidy } from '../../../interfaces/Subsidy.interfaces';
import { createURLSearchParams } from '../../../utils/creator/createURLSearchParams.util';
import { customAxios } from '../../common/customAxios';

interface IGetSubsidiesParams {
  searchParam?: {
    count?: number;
    page?: number;
    state?: string;
    city?: string;
    tagName?: string;
  };
}

export const getSubsidies = ({ searchParam }: IGetSubsidiesParams): Promise<ISubsidy[]> => {
  const URLSearchParams = createURLSearchParams(searchParam ?? {});
  return customAxios.get(`/subsidies?${URLSearchParams}`);
};
